import React from 'react';
import {
    Grid, Box, Button,
    Card, Typography, CardContent, CardActions, CardHeader, CardMedia,
    Avatar, IconButton, 
} from '@mui/material';

import { Link } from 'react-router-dom';
import {Stack, Chip} from '@mui/material';

import { red } from '@mui/material/colors';
//import MoreVertIcon from '@mui/icons-material/MoreVert';

import CloudOn from '@mui/icons-material/Cloud';
import CloudOff from '@mui/icons-material/CloudQueue';

const Draft = props => {
    return (
        <Box m={2}>
            <Grid container spacing={3}>
                
                <Grid item xs={4}>
                    <Card variant="outlined">
                        <CardHeader
                            avatar={
                                <Avatar aria-label="recipe" sx={{ bgcolor: red[0] }} src="/devil_avatar.png"/>
                            }
                            action={
                            <IconButton aria-label="settings">
                                <CloudOn />
                            </IconButton>
                            }
                            title="Devil Admin"
                            subheader="0.1"
                        />
                        <CardMedia
                            component="img"
                            height="194"
                            image="/preview.png"
                            alt="Paella dish"
                        />
                        <CardContent>
                            <Typography gutterBottom variant="h5" component="div">
                              좌석 예약
                            </Typography>
                            <Box mt={1} mb={1}>
                                <Stack direction="row" spacing={1}>
                                    <Chip label="App" color="primary" />
                                    <Chip label="Front" color="success" />
                                    <Chip label="Admin" color="secondary" />
                                </Stack>
                            </Box>
                            
                            <Typography paragraph>
                                관리자에서 예약 가능 날짜, 시간, 좌석, 예약 대상을 설정하고,
                                앱에서 예약을 받고 모바일 티켓을 받는 시스템
                            </Typography>

                        </CardContent>
                        <CardActions>
                            <Button size="small">사용중</Button>
                            <Button size="small" 
                                component={Link}
                                to={{ pathname: "/package/tutorial/1" }}>
                                    체험하기</Button>
                                    
                        </CardActions>
                    </Card>
                </Grid>

                <Grid item xs={4}>
                    <Card variant="outlined">
                        <CardHeader
                            avatar={
                                <Avatar aria-label="recipe" sx={{ bgcolor: red[0] }} src="/devil_avatar.png"/>
                            }
                            action={
                            <IconButton aria-label="settings">
                                <CloudOff />
                            </IconButton>
                            }
                            title="Devil Admin"
                            subheader="0.1"
                        />
                        <CardMedia
                            component="img"
                            height="194"
                            image="/preview2.png"
                            alt="Paella dish"
                        />
                        <CardContent>
                            <Typography gutterBottom variant="h5" component="div">
                              정산
                            </Typography>
                            <Box mt={1} mb={1}>
                                <Stack direction="row" spacing={1}>
                                    <Chip label="Front" color="success" />
                                    <Chip label="Admin" color="secondary" />
                                </Stack>
                            </Box>
                            
                            <Typography paragraph>
                                정산 API, 백앤드 관리자
                            </Typography>
                        </CardContent>
                        <CardActions>
                            <Button size="small">사용하기</Button>
                            <Button size="small">체험하기</Button>
                        </CardActions>
                    </Card>
                </Grid>
                
            </Grid>
        </Box>
    )
};

export default Draft;